import React from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions/allActions";
import { FormColor } from "../../../components/form/FormColor";
import { FormInput } from "../../../components/form/FormInput";
import FormTextArea from "../../../components/form/FormTextArea";
import { RootState } from "../../../reducers/combineReducer";
import { pageMessages, pageStyling } from "../../../types/types";

interface PageStylingProps {}

export const PageStylingForm: React.FC<PageStylingProps> = () => {
  const {
    pageDescription,
    pageHeader,
    pageRegistrationFullHeader,
    pageRegistrationFullText,
    pageThankYouHeader,
    pageregistrationNotYetOpenText,
    pageThankYouText,
    pageregistrationEndedHeader,
    pageregistrationEndedText,
    pageregistrationNotYetOpenHeader,
  }: pageMessages = useSelector(
    (state: RootState) =>
      state["eventState"]["registrationState"]["pageMessages"]
  );

  const { backgroundColor }: pageStyling = useSelector(
    (state: RootState) =>
      state["eventState"]["registrationState"]["pageStyling"]
  );

  const dispatch = useDispatch();
  const rowDiv = "w-full flex flex-wrap justify-evenly";
  const divs = "w-1/4";

  const useFormatMessage = (messageId: string) => {
    return useIntl().formatMessage({ id: messageId });
  };

  const handleNestedItemChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
      | string,
    id: string
  ) => {
    const value = typeof event === "string" ? event : event.target.value;
    const itemValues = id.split(":");
    dispatch(
      allActions.eventActions.changePageStyling(
        itemValues[1],
        value,
        itemValues[0]
      )
    );
  };

  return (
    <div className='w-full divide-y-2 divide-gray-300'>
      <div className='flex justify-evenly divide-x divide-gray-200'>
        <FormInput
          value={pageHeader || ""}
          question={useFormatMessage("Form.SubEvent.PageHeader")}
          handleInputChange={handleNestedItemChange}
          id='pageHeader:pageMessages'
          type='text'
        />
        <FormTextArea
          value={pageDescription || ""}
          question={useFormatMessage("Form.SubEvent.PageDescription")}
          handleInputChange={handleNestedItemChange}
          id='pageDescription:pageMessages'
        />
      </div>
      <div className={rowDiv}>
        <FormInput
          value={pageThankYouHeader || ""}
          divStyle={divs}
          question={useFormatMessage("Form.SubEvent.pageThankYouHeader")}
          handleInputChange={handleNestedItemChange}
          id='pageThankYouHeader:pageMessages'
          type='text'
        />
        <FormTextArea
          value={pageThankYouText || ""}
          divStyle={divs}
          question={useFormatMessage("Form.SubEvent.pageThankYouText")}
          handleInputChange={handleNestedItemChange}
          id='pageThankYouText:pageMessages'
        />
        <FormInput
          value={pageRegistrationFullHeader || ""}
          divStyle={divs}
          question={useFormatMessage(
            "Form.SubEvent.PageRegistrationFullHeader"
          )}
          handleInputChange={handleNestedItemChange}
          id='pageRegistrationFullHeader:pageMessages'
          type='text'
        />
        <FormTextArea
          value={pageRegistrationFullText || ""}
          divStyle={divs}
          question={useFormatMessage("Form.SubEvent.pageRegistrationFullText")}
          handleInputChange={handleNestedItemChange}
          id='pageRegistrationFullText:pageMessages'
        />
      </div>
      <div className={rowDiv}>
        <FormInput
          value={pageregistrationNotYetOpenHeader || ""}
          divStyle={divs}
          question={useFormatMessage(
            "Form.SubEvent.pageregistrationNotYetOpenHeader"
          )}
          handleInputChange={handleNestedItemChange}
          id='pageregistrationNotYetOpenHeader:pageMessages'
          type='text'
        />
        <FormTextArea
          value={pageregistrationNotYetOpenText || ""}
          divStyle={divs}
          question={useFormatMessage(
            "Form.SubEvent.pageregistrationNotYetOpenText"
          )}
          handleInputChange={handleNestedItemChange}
          id='pageregistrationNotYetOpenText:pageMessages'
        />
        <FormInput
          value={pageregistrationEndedHeader || ""}
          divStyle={divs}
          question={useFormatMessage(
            "Form.SubEvent.pageregistrationEndedHeader"
          )}
          handleInputChange={handleNestedItemChange}
          id='pageregistrationEndedHeader:pageMessages'
          type='text'
        />
        <FormTextArea
          value={pageregistrationEndedText || ""}
          divStyle={divs}
          question={useFormatMessage("Form.SubEvent.pageregistrationEndedText")}
          handleInputChange={handleNestedItemChange}
          id='pageregistrationEndedText:pageMessages'
        />
      </div>
      <div className={rowDiv}>
        <FormColor
          value={backgroundColor || "#ff0000"}
          question={useFormatMessage("Form.SubEvent.backgroundColor")}
          handleInputChange={handleNestedItemChange}
          id='backgroundColor:pageStyling'
        />
      </div>
    </div>
  );
};

export default PageStylingForm;
